import { ValueFormatterParams } from 'ag-grid-community';
import { formatCurrency, formatNumber, formatPercent } from 'modules/I18N';
import { AggregationFunction } from 'components/common/AllocationReport/AllocationReport.types';
import { MetricType, ValueFormatter } from 'components/common/types/DrilldownReports.types';

const formatNumberValue = (value: number, localeCode: string): string => formatNumber({ value, localeCode, digits: 0 });
const formatPercentValue = (value: number, localeCode: string): string =>
  formatPercent({ value, localeCode, maximumFractionDigits: 2 });
const formatCurrencyValue = (value: number, localeCode: string, currencyCode?: string): string =>
  formatCurrency({ value, localeCode, currencyCode: currencyCode as string });

export const valueFormatters: Record<MetricType, ValueFormatter> = {
  [MetricType.IMPRESSIONS]: formatNumberValue,
  [MetricType.SOT]: formatPercentValue,
  [MetricType.FRAMES]: formatNumberValue,
  [MetricType.PRICE_GROSS]: formatCurrencyValue,
  [MetricType.PRICE_INDEXED]: formatCurrencyValue,
  // [MetricType.REPETITIONS]: formatNumberValue,
  [MetricType.DELIVERED_IMPRESSIONS]: formatNumberValue,
  [MetricType.DELIVERED_SOT]: formatPercentValue,
  // [MetricType.DELIVERED_PRICE_GROSS]: formatCurrencyValue,
  // [MetricType.DELIVERED_PRICE_INDEXED]: formatCurrencyValue,
  [MetricType.DELIVERED_PLAYS]: formatNumberValue,
};

export const createValueFormatter = (selectedMetricType: MetricType, localeCode: string, currencyCode?: string) => {
  return (params: ValueFormatterParams): string => {
    if (params.value === 0) {
      return '-';
    }

    if (typeof params.value === 'number') {
      return valueFormatters[selectedMetricType](params.value, localeCode, currencyCode);
    }

    if (params.colDef.aggFunc === AggregationFunction.AVG && params?.value?.value != null) {
      return valueFormatters[selectedMetricType](params.value.value, localeCode, currencyCode);
    }

    return '';
  };
};
